// This file was automatically generated from appshared.dialog.createPatient.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.dialog.createPatient');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appshared.dialog.patientForm');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.createPatient.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form id="create-patient-form" class="ebs-form-horizontal" autocomplete="off"><div class="alertWrap"><div class="alert-msg alertCaution ebs-alert ebs-alert-warning"></div></div>');
  el8.template.appshared.dialog.patientForm.contents(opt_data, output);
  output.append('</form>');
  if (!opt_sb) return output.toString();
};
